<template>
    <svg width="58" height="50" viewBox="0 0 58 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2194_901)">
            <path d="M49.8438 16.6666H8.15625V39.4977H49.8438V16.6666Z" stroke="currentColor" stroke-width="3"
                stroke-linecap="round" stroke-linejoin="round" />
            <path
                d="M11.7812 7.99084H46.2188C48.2193 7.99084 49.8438 9.62783 49.8438 11.6438V16.6666H8.15625V11.6438C8.15625 9.62783 9.7807 7.99084 11.7812 7.99084Z"
                stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
            <path
                d="M49.8438 39.4977V44.5205C49.8438 46.5376 48.2204 48.1735 46.2188 48.1735H31.9453C30.3186 48.1735 29 46.8447 29 45.2054H11.7812C9.77957 45.2054 8.15625 43.5696 8.15625 41.5525V39.4977H49.8438Z"
                stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
            <path opacity="0.2"
                d="M49.8438 16.6666V39.4977H28.6602C38.4318 36.3093 45.6421 27.3858 46.3819 16.6666H49.8438Z"
                fill="currentColor" />
            <path opacity="0.2"
                d="M49.8439 11.6438V16.6666H39.7573C42.3379 15.1118 44.0665 12.2682 44.0665 9.01824C44.0665 8.67121 44.0473 8.3276 44.0076 7.99084H46.2189C48.2206 7.99084 49.8439 9.62669 49.8439 11.6438Z"
                fill="currentColor" />
            <path opacity="0.2"
                d="M49.8439 39.4977V44.5205C49.8439 46.5376 48.2206 48.1735 46.2189 48.1735H36.479C40.2252 46.6769 43.1105 43.4634 44.1799 39.4977H49.8439Z"
                fill="currentColor" />
            <path d="M8.15625 14.3835H1.8125V25.7991H8.15625V14.3835Z" stroke="currentColor" stroke-width="3"
                stroke-linecap="round" stroke-linejoin="round" />
            <path d="M56.1875 31.5068H49.8438V42.9224H56.1875V31.5068Z" stroke="currentColor" stroke-width="3"
                stroke-linecap="round" stroke-linejoin="round" />
            <path d="M18.8047 24.6576V28.5389C18.8047 31.1873 20.9344 33.3334 23.5625 33.3334H49.8438" stroke="currentColor"
                stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M25.6016 24.6576V28.5389C25.6016 31.1873 27.7312 33.3334 30.3594 33.3334H32.8516" stroke="currentColor"
                stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M32.3984 24.6576V28.5389C32.3984 31.1873 34.5281 33.3334 37.1562 33.3334H39.6484" stroke="currentColor"
                stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M39.1953 24.6576V28.5389C39.1953 31.1873 41.325 33.3334 43.9531 33.3334H46.4453" stroke="currentColor"
                stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M16.3125 24.6576H41.6875" stroke="currentColor" stroke-width="3" stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M16.9922 1.82654H20.6172C21.9924 1.82654 23.1094 2.95211 23.1094 4.33795V7.99092H14.5V4.33795C14.5 2.95211 15.617 1.82654 16.9922 1.82654Z"
                stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
            <path opacity="0.2"
                d="M8.15625 19.1472V25.799H1.8125V21.9098C1.92465 21.9155 2.03793 21.9178 2.15234 21.9178C4.55164 21.9178 6.70172 20.8436 8.15625 19.1472Z"
                fill="currentColor" />
            <path opacity="0.2"
                d="M56.1875 35.67V42.9223H49.8438V39.2442C50.0307 39.2614 50.2198 39.2694 50.4102 39.2694C52.9386 39.2694 55.1283 37.8047 56.1875 35.67Z"
                fill="currentColor" />
            <path opacity="0.2"
                d="M23.1095 4.33795V7.99092H16.8076C18.8263 6.69412 20.1641 4.41786 20.1641 1.82654H20.6173C21.9936 1.82654 23.1095 2.95097 23.1095 4.33795Z"
                fill="currentColor" />
        </g>
        <defs>
            <clipPath id="clip0_2194_901">
                <rect width="58" height="50" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>